// Unified player eligibility status display

import MarkedText from './MarkedText';
import './PlayerStatus.scss';

export default function PlayerStatus({ verified, waiverSigned, tooOld }) {
  return (
    <div className='player-status'>
      {verified != null && (
        <MarkedText
          text={verified ? 'Age verified' : 'Age not verified'}
          mark={verified ? 'check' : 'cross'}
        />
      )}
      {tooOld && <MarkedText text='Too old' mark='cross' />}
      {waiverSigned != null && (
        <MarkedText
          text={waiverSigned ? 'Waiver signed' : 'Waiver not signed'}
          mark={waiverSigned ? 'check' : 'cross'}
        />
      )}
    </div>
  );
}
